/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */

import '@polymer/iron-iconset-svg/iron-iconset-svg.js';
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<iron-iconset-svg name="cs-cta-in-text" style="display: none;">
<svg>
  <g id="information" viewBox="0 0 14 14">
    <path d="M7.7125 4.79746C7.7125 5.15645 7.42148 5.44746 7.0625 5.44746C6.70351 5.44746 6.4125 5.15645 6.4125 4.79746C6.4125 4.43848 6.70351 4.14746 7.0625 4.14746C7.42148 4.14746 7.7125 4.43848 7.7125 4.79746Z"></path>
    <path d="M6.4125 6.74746V10.6475H7.7125V6.74746H6.4125Z"></path>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5625 7.39746C0.5625 3.80761 3.47265 0.897461 7.0625 0.897461C10.6524 0.897461 13.5625 3.80761 13.5625 7.39746C13.5625 10.9873 10.6524 13.8975 7.0625 13.8975C3.47265 13.8975 0.5625 10.9873 0.5625 7.39746ZM7.0625 2.19746C4.19062 2.19746 1.8625 4.52558 1.8625 7.39746C1.8625 10.2693 4.19062 12.5975 7.0625 12.5975C9.93438 12.5975 12.2625 10.2693 12.2625 7.39746C12.2625 4.52558 9.93438 2.19746 7.0625 2.19746Z"></path>
  </g>
  <g id="asterisk" viewBox="0 0 14 14">
    <path d="M13.5621 4.74924L12.4219 2.87283L8.20529 5.18463V0.561035H5.91971V5.18463L1.70307 2.87283L0.5625 4.74924L4.78021 7.06104L0.562822 9.37283L1.70304 11.2492L5.91971 8.93744V13.561H8.20529V8.93744L12.4219 11.2492L13.5625 9.37283L9.34479 7.06104L13.5621 4.74924Z"></path>
  </g>
</svg>
</iron-iconset-svg>`;

document.head.appendChild($_documentContainer.content);
